import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { SetNewPassword } from '../store/auth.actions';
import { ActivatedRoute } from '@angular/router';
import { GetConfigurations } from 'src/app/features/home/configurations/store/configurations.actions';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-set-password',
    templateUrl: './set-password.component.html',
    styleUrls: ['./set-password.component.scss']
})
export class SetPasswordComponent implements OnInit {
    setNewPasswordform;
    showPassword: boolean;
    showNewPassword: boolean;
    showConfirmPassword: boolean;
    configObj: any;
    passwordEntered: any;
    numRegex: RegExp;
    specialCharregex: RegExp;
    upperCaseregex: RegExp;
    wrongPasswordFormat: boolean;
    stopper$: Subject<any> = new Subject();
    passwordValidationMsg: string = 'Password must contain a minimum of 7 characters; a maximum of 15 characters; at least one special character (*, /, @, #, etc.); at least one uppercase character and at least two digits';
    constructor(private fb: FormBuilder, public store: Store<AppState>, private route: ActivatedRoute) {
        this.showPassword = false;
    }

    ngOnInit() {
        this.setNewPasswordform = this.fb.group({

            password: [
                '',
                Validators.compose([
                    Validators.required,
                    Validators.pattern(
                        "(?=.*?[#?!@$%^&*-]).{6,}"
                    )
                ])
            ],
            confirmpwd: [
                '',
                Validators.compose([
                    Validators.required,
                ]),
            ],
        }, {
            validator: MustMatch('password', 'confirmpwd'),
        });

        this.store.dispatch(new GetConfigurations);
        this.store.select(state => state.configurations.configurations).pipe(takeUntil(this.stopper$)).subscribe((resp: any) => {
            if (Object.keys(resp).length) {
                console.log("here", resp);
                this.configObj = resp;
                const passwordMinLength = +resp['passwordMinLength'].value;
                const passwordMaxLength = +resp['passwordMaxLength'].value;
                this.setNewPasswordform.get('password').setValidators([
                    Validators.required,
                    Validators.minLength(passwordMinLength),
                    Validators.maxLength(passwordMaxLength),
                ])

                this.passwordValidationMsg = `Password must contain a minimum of ${passwordMinLength} characters; a
                maximun of ${passwordMaxLength} characters`

                if (resp['specialCharCount'].value != 0) {
                    this.passwordValidationMsg += `; at least ${+resp['specialCharCount'].value} special character(s) (*, /, @, #, etc.)`
                }
                if (resp['upperCaseCount'].value != 0) {
                    this.passwordValidationMsg += `; at least ${+resp['upperCaseCount'].value} uppercase character(s)`
                }
                if (resp['numCount'] != 0) {
                    this.passwordValidationMsg += ` and at least ${+resp['numCount'].value} digit(s)`
                }
            }
        })

        this.setNewPasswordform.get('password').valueChanges.subscribe((password) => {
            let upperCaseCount = parseInt(this.configObj['upperCaseCount'].value);
            let specialCharCount = parseInt(this.configObj['specialCharCount'].value);
            let passwordMaxLength = parseInt(this.configObj['passwordMaxLength'].value);
            let passwordMinLength = parseInt(this.configObj['passwordMinLength'].value);
            let numCount = parseInt(this.configObj['numCount'].value);
            this.passwordEntered = password;

            this.numRegex = new RegExp(`((.*[0-9]){${numCount},}.*)`);
            this.upperCaseregex = new RegExp(`((.*[A-Z]{${upperCaseCount},}.*))`)
            this.specialCharregex = new RegExp(`(.*[@#$%]){${specialCharCount},}.*`)
            if (password.length >= passwordMinLength && password.length <= passwordMaxLength) {
                if (this.numRegex.test(password)) {
                    this.wrongPasswordFormat = false;
                    if (this.upperCaseregex.test(password)) {
                        this.wrongPasswordFormat = false;
                        if (this.specialCharregex.test(password)) {
                            this.wrongPasswordFormat = false;
                        } else {
                            this.wrongPasswordFormat = true;
                        }
                    } else {
                        this.wrongPasswordFormat = true;
                    }
                } else {
                    this.wrongPasswordFormat = true;
                }
            } else {
                this.wrongPasswordFormat = true;
            }
        })
    }
    // showPasswordFunction() {
    //     this.showPassword = !this.showPassword;
    // }

    setNewPassword() {
        if (this.setNewPasswordform.invalid) {
            return false;
        }

        let password = this.setNewPasswordform.value.password;
        let userId = this.route.snapshot.queryParamMap.get("userId");

        this.store.dispatch(new SetNewPassword(password, userId));
    }

    fieldMatcher(field: string, errorKey: string) {
        return function (control: FormControl): { [s: string]: boolean } {
            if (!control.parent) return null;
            return control.parent.get(field).value === control.value
                ? null
                : { [errorKey]: true };
        };
    }

    ngOnDestroy() {
        this.stopper$.next();
        this.stopper$.complete();
    }

    restrictSpace(event: KeyboardEvent) {
        let x = event.keyCode;
        if (x == 32) {
            return false;
        }
    }
}

export function MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}